shadow$provide[376] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `void setFragmentColor(vec4 color) {
  gl_FragColor = color;
}`;

};